import { render, staticRenderFns } from "./EditEntry.vue?vue&type=template&id=35cbddb7&"
import script from "./EditEntry.vue?vue&type=script&lang=js&"
export * from "./EditEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports